import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ArrowDown, Check } from "lucide-react";

const DropdownMenu = ({
  buttonText = "Options",
  items = [],
  className = "w-full",
  buttonClassName = "inline-flex items-center gap-2 rounded-md bg-gray-800 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:not-data-focus:outline-none data-focus:outline data-focus:outline-white data-hover:bg-gray-700 data-open:bg-gray-700",
  menuItemsClassName = "origin-top-right rounded-xl border border-white/5 bg-white/5 p-1 text-sm/6 text-white transition duration-100 ease-out [--anchor-gap:--spacing(1)] focus:outline-none data-closed:scale-95 data-closed:opacity-0",
  onChange = () => {},
  selectedValue = null,
}) => {
  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    }
    onChange(item.value);
  };

  return (
    <div className={className}>
      <Menu as="div" className="relative inline-block w-full text-left">
        <MenuButton className={buttonClassName}>
          {buttonText}
          <ArrowDown className="size-4 fill-white/60" />
        </MenuButton>

        <div className="absolute z-10 w-full">
          <MenuItems
            // transition
            className={menuItemsClassName}
          >
            {items.map((item, index) => {
              const isSelected = selectedValue === item.value;
              return (
                <MenuItem key={item.value || index}>
                  <button
                    type="button"
                    className="group flex w-full items-center gap-2 rounded-lg px-3 py-1.5 hover:bg-gray-100 data-focus:bg-gray-100 transition-colors duration-150"
                    onClick={() => handleItemClick(item)}
                  >
                    {item.icon && (
                      <item.icon className="size-4 text-gray-500" />
                    )}
                    <span className="flex-grow text-left">{item.label}</span>
                    {isSelected && <Check className="size-4 text-blue-500" />}
                    {item.shortcut && (
                      <kbd className="ml-auto hidden font-sans text-xs text-gray-500 group-data-focus:inline">
                        {item.shortcut}
                      </kbd>
                    )}
                  </button>
                </MenuItem>
              );
            })}
          </MenuItems>
        </div>
      </Menu>
    </div>
  );
};

export default DropdownMenu;
